import { render } from "./Streets.vue?vue&type=template&id=279f4f06&scoped=true"
import script from "./Streets.vue?vue&type=script&lang=js"
export * from "./Streets.vue?vue&type=script&lang=js"

import "./Streets.vue?vue&type=style&index=0&id=279f4f06&scoped=true&lang=scss"

import exportComponent from "/Users/kovacsistvan/develop/segito-kezek/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279f4f06"]])

export default __exports__